import React, {useEffect, useState} from 'react';
import {StudentsItem} from "components/pages/groups/group-container/students/students-item/StudentsItem";
import {useAppDispatch, useAppSelector} from "common/hook";

import {Student} from "features/model/types/studentsSchema";
import {useParams} from "react-router-dom";
import {
    fetchStudentsByGroupId
} from "features/model/service/groups/groups-students/fetchStudentsByGroupId";
import {NothingYetMessage} from "../../../personal-cabinet/nothing-yet-message/NothingYetMessage";
import {Preloader} from "components/layout/preloader/Preloader";
import {CustomPagination} from "components/pagination/CustomPagination";



export const Students = () => {
    const paginationData = useAppSelector((state) => state.students.pagination);
    const {page, pageSize, pageCount} = paginationData;
    const studentsData = useAppSelector((state) => state.students);
    const {students, isLoading, error} = studentsData
    const dispatch = useAppDispatch();
    const {groupId} = useParams();



    const onChangeHandle = (event: React.ChangeEvent<unknown>, value: number) => {
        dispatch(fetchStudentsByGroupId({groupId, page: value -1}));
    };

    useEffect(() => {
        dispatch(fetchStudentsByGroupId({groupId}));
    }, [dispatch, groupId]);



    return (
        <div className="tabs-content">
            <div className="tab">
                <div className="data-tbl inner-group-students-tbl">
                    <div className="row thead">
                        <div className="col student-col">Студент</div>
                        <div className="col first-level-col">Начальный уровень</div>
                        <div className="col current-level-col">Текущий уровень</div>
                        <div className="col classes-attended-col align-right">Посещенные занятия</div>
                        <div className="col passes-col align-right">Пропуски</div>
                        <div className="col homecurrenttasks-col align-right">Домашние задания</div>
                    </div>


                    {isLoading ? (
                        <Preloader/>
                    ) : students && students.length > 0 ? (
                        students.map((student: Student) => (
                            <StudentsItem key={student.id} student={student}/>
                        ))
                    ) : (
                        <NothingYetMessage/>
                    )}

                    {pageCount > 1 && (
                        <CustomPagination pageCount={pageCount} onChangeHandle={onChangeHandle} />
                    )}
                </div>
            </div>
        </div>
    );
};

